import LabelLang from "component/LabelLang/label-lang";
import { DateFormater } from "functions/dateTimeFormat";
import { Col, Container, Row } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";

const TreandingNewsCard = ({ headerTitle, title, date, id, translations }) => {
  return (
    <Link to={`/mediaLanding/news/${id}`} className="card pe-3">
      <Container>
        <Row>
          <Col>
            <label className="date">
              <DateFormater value={date} />
            </label>
          </Col>
        </Row>
        <Row>
          <Col>
            <label className="title">
              <LabelLang
                id="title"
                defaultValue={title}
                translations={translations}
              />
            </label>
          </Col>
        </Row>
        <Row className="go-to-news-row">
          <Col>
            <label className="go-to-news">
              <FormattedMessage id="read-news" />
            </label>
          </Col>
        </Row>
      </Container>
    </Link>
  );
};

export default TreandingNewsCard;
